import { memo, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import type { CMSKameleoonSlotDTO } from "~/features/cms/types/dto";

interface Props extends Omit<CMSKameleoonSlotDTO, "type"> {
  className?: string;
}

const CMSKameleoonSlot = ({ featureFlagName, functionName }: Props) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  const isFeatureEnabled = window.SCHA?.feature?.[featureFlagName] === true;

  useEffect(() => {
    if (!isFeatureEnabled) {
      return;
    }

    const parent = containerRef.current;
    const renderFunction = window.SCHA?.kameleoon?.[functionName];

    if (parent && typeof renderFunction === "function") {
      renderFunction(parent, t);
    }
  }, [isFeatureEnabled, functionName, t]);

  if (!isFeatureEnabled) {
    return null;
  }

  return <div ref={containerRef} />;
};

export default memo(CMSKameleoonSlot);
